import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TagManager from '@sooro-io/react-gtm-module';
import axios from "axios";
import mixpanel from "mixpanel-browser";
import React, { Component } from "react";
import Autocomplete from "react-google-autocomplete";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import LightboxHalfScreenComponent from "../../lightboxHalfScreen/components/LightboxHalfScreenComponent";
import SpinnerComponent from "../../spinner";
import "../style/RegisterModal.scss";

class RegisterModalComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companyType: props.companyType ? props.companyType : "",
      companyName: "",
      companyWebsite: "",
      yearEstablished: "",
      location: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      defaultOption: "",
      locationFields: [{ glocations: null }],
      locations: [],
      registerSuccess: false,
      emailAlreadyInUser: false,
      emailAlreadyInPreOrder: false,
      isLoading: false,
      companyWebSiteUrl: false,
      msg: "",
      fieldError: false,
      eventSegments: false,
      eventSegmentsSelected: [],
      available_for_mailing: false,
    };
  }

  componentDidMount() {
    this.fetchData();

    if(this.props.email) {
      this.setState({email: this.props.email})
    }
  }

  getCookie(cookieName) {
    let cookie = {};
    document.cookie.split(';').forEach(function (el) {
      let [key, value] = el.split('=');
      cookie[key.trim()] = value;
    })
    return cookie[cookieName];
  }

  addLocationField() {
    let state = this.state;
    state.locationFields.push({ glocations: null });

    this.setState({
      locationFields: state.locationFields,
    });
  }

  fetchEventSegments() {
    return axios
      .get(`${process.env.REACT_APP_NEW_API_URL}/v1/event-segment`)
      .then((response) => {
        let items = response.data.results;

        items = items.filter((item) => item.is_active_event);

        let path = this.props.location.pathname;
        path = path.split("/");

        let eventSegment = "";

        if (localStorage.getItem("defaultEvent")) {
          eventSegment = localStorage.getItem("defaultEvent");
          eventSegment = eventSegment.split("/");
        }

        if (path.length > 0) {
          let eventosFiltrados = items.filter(
            (item) => item.slug === path[1] || item.slug === eventSegment[1]
          );

          if (eventosFiltrados.length >= 1) {
            items = eventosFiltrados;
            return this.setState({
              defaultOption: items.map((item) => {
                return { value: item.id, label: item.name };
              })[0],
              eventSegmentsSelected: items.map((item) => item.id),
              eventSegments: items,
              isLoading: false,
            });
          }
        }

        this.setState({
          eventSegments: items,
        });
      });
  }

  fetchCountries() {
    return axios
      .get(`${process.env.REACT_APP_NEW_API_URL}/v1/locations`)
      .then((response) => this.setState({ countries: response.data.data }));
  }

  async fetchData() {
    this.setState({ isLoading: true });

    Promise.all([this.fetchEventSegments(), this.fetchCountries()]).then(() =>
      this.setState({ isLoading: false })
    );
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  setCompanyLocation(place, index) {
    let state = this.state;
    state.locationFields[index].glocations = place.formatted_address;

    this.setState({
      locationFields: state.locationFields,
    });
  }

  removeLocation(index) {
    let state = this.state;
    state.locationFields.splice(index, 1);
    this.setState({
      locationFields: state.locationFields,
    });
  }

  setFieldError(message) {
    this.setState(
      {
        fieldError: message,
      },
      () => {
        document.querySelector(".lh-modal-body").scroll({
          left: 0,
          top: document.querySelector(".lh-modal-body").scrollHeight,
          behavior: "smooth",
        });
      }
    );
  }

  handleChangeSelectEvent(value) {
    this.setState({
      eventSegmentsSelected: value.map((item) => item.value),
    });
  }

  handleChangeSelectCountry(value) {
    this.setState({
      locations: value.map((item) => item.value),
    });
  }

  selectOptions(items) {
    return items.map((item) => {
      return {
        value: item.id,
        label: item.name,
        isOptionSelected: item.id === this.state.defaultOption,
      };
    });
  }

  selectOptionsCountries(items) {
    return items.map((item) => {
      return {
        value: item.name,
        label: item.name,
      };
    });
  }

  pre(event) {
    event.preventDefault();

    let state = this.state;
    const { t } = this.props;

    if (!state.companyType) {
      this.setFieldError(
        t("Company type is invalid", "Company type is invalid")
      );
      return;
    }

    if (!state.companyName) {
      this.setFieldError(
        t("Company name is invalid", "Company name is invalid")
      );
      return;
    }

    if (!state.companyWebsite) {
      this.setFieldError(
        t("Company website or instagram is invalid", "Company website or instagram is invalid")
      );
      return;
    }

    const websiteRegex = /^(http(s)?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)$/;
    const InstagramRegex = /^(http(s)?:\/\/)(www\.)?instagram\.com\/(.*)$/;
    if (!websiteRegex.test(state.companyWebsite) && !InstagramRegex.test(state.companyWebsite)) {
    this.setFieldError(
    t("Invalid website or instagram URL format", "Invalid website or instagram URL format")
    );
    return;
    }

    if (!state.yearEstablished) {
      this.setFieldError(
        t("Year Established is invalid", "Year Established is invalid")
      );
      return;
    }

    if (isNaN(state.yearEstablished)) {
      this.setFieldError(
        t(
          "Year Established must be numeric",
          "Year Established must be numeric"
        )
      );
      return;
    }

    if (!state.firstName) {
      this.setFieldError(t("First Name is invalid", "First Name is invalid"));
      return;
    }

    if (!state.lastName) {
      this.setFieldError(t("Last Name is invalid", "Last Name is invalid"));
      return;
    }

    if (!state.phone) {
      this.setFieldError(t("Phone is invalid", "Phone is invalid"));
      return;
    }

    if (!state.email) {
      this.setFieldError(t("Email is invalid", "Email is invalid"));
      return;
    }

    if (state.locationFields.length < 1) {
      this.setFieldError(
        t(
          "Error: Location of Business Operation is required",
          "Error: Location of Business Operation is required"
        )
      );
      return;
    }

    if (state.locations.length < 1) {
      this.setFieldError(
        t("Error: Country is required", "Error: Country is required")
      );
      return;
    }

    const formData = new FormData();
    formData.append("type", state.companyType);
    formData.append("company_name", state.companyName);
    formData.append("company_website", state.companyWebsite);
    formData.append("year_established", state.yearEstablished);
    formData.append("first_name", state.firstName);
    formData.append("last_name", state.lastName);
    formData.append("email", state.email);
    formData.append("phone", state.phone);
    formData.append("client_tracking_id", this.getCookie("rdtrk") || null);
    formData.append("traffic_source", this.getCookie("__trf.src") || null);
    formData.append(
      "available_for_mailing",
      state.available_for_mailing ? 1 : 0
    );

    if (state.eventSegmentsSelected) {
      state.eventSegmentsSelected.forEach((element) => {
        formData.append("event_segments[]", element);
      });
    }

    if (state.locations) {
      state.locations.forEach((element) => {
        formData.append("locations[]", element);
      });
    }

    if (state.locationFields) {
      state.locationFields.forEach((element) => {
        if (element.glocations) {
          formData.append("glocations[]", element.glocations);
        }
      });
    }

    this.setState({
      fieldError: false,
      isLoading: true,
    });

    axios
      .post(`${process.env.REACT_APP_NEW_API_URL}/v1/preregistration`, formData)
      .then((response) => {
        if (
          process.env.REACT_APP_MIXPANEL_ENABLED === true ||
          process.env.REACT_APP_MIXPANEL_ENABLED === "true"
        ) {
          mixpanel.track("Sign up");
        }

        // Google Tag Manager event: registration
        const tagManagerArgs = {
            dataLayer: {
                event: 'registration',
                company_type: "Retailer",
            },
        };
        if(formData.type === "s")
            tagManagerArgs.dataLayer.companyType = "Brand";
        TagManager.dataLayer(tagManagerArgs);

        this.setState({
          registerSuccess: true,
          isLoading: false,
        });
      })
      .catch((error) => {
        if (
          error.response.data.email &&
          error.response.data.email[0] ===
          "user with this email already exists."
        ) {
          this.setState({
            emailAlreadyInUser: true,
            emailAlreadyInPreOrder: false,
            isLoading: false,
          });

          return;
        } else if (
          error.response.data.email &&
          error.response.data.email[0] ===
          "pré-cadastro com este email já existe."
        ) {
          this.setState({
            emailAlreadyInPreOrder: true,
            isLoading: false,
          });

          return;
        } else {
          this.setState({
            emailAlreadyInUser: false,
            emailAlreadyInPreOrder: false,
            isLoading: false,
          });
        }

        if (
          error.response.data.company_website &&
          error.response.data.company_website[0]
        ) {
          this.setState({
            companyWebSiteUrl: true,
            isLoading: false,
          });

          return;
        } else {
          this.setState({
            companyWebSiteUrl: false,
            isLoading: false,
          });
        }

        this.setState({
          fieldError: error.response.data[Object.keys(error.response.data)[0]],
          isLoading: false,
        });
      });
  }

  render() {
    const { t } = this.props;
    return (
      <LightboxHalfScreenComponent
        extraClass="register-lh-modal"
        close={this.props.close}
      >
        <div id="register-modal">
          {!this.state.registerSuccess && (
            <div className="title-and-description">
              <h2>
                {t(
                  "LET'S START YOUR REGISTRATION",
                  "LET'S START YOUR REGISTRATION"
                )}
              </h2>
              <div className="description">
                {this.state.companyType === "b" &&
                  t(
                    "register_b_subtitle",
                    "WE WANT TO CONNECT YOU TO THE RIGHT BRANDS AND MAKE THEM VIABLE WHEREVER YOU ARE."
                  )}
                {this.state.companyType === "s" &&
                  t(
                    "register_s_subtitle",
                    "Take your brand to an international level, with professionalism and consistency. We’re always looking for those who stand out to put them under the world’s spotlight!"
                  )}
              </div>
            </div>
          )}
          <div className="registration-title-box">
            {this.state.registerSuccess ? (
              <p>
                {" "}
                {t(
                  "PLEASE CHECK YOUR EMAIL INBOX",
                  "PLEASE CHECK YOUR EMAIL INBOX"
                )}{" "}
              </p>
            ) : (
              <span className="subtitle">
                {t("COMPANY INFO", "COMPANY INFO")}
              </span>
            )}
          </div>
          <form name="preRegistration" onSubmit={this.pre.bind(this)}>
            <div className="container">
              {!this.state.registerSuccess && (
                <React.Fragment>
                  <div className="company-info">
                    <select
                      value={this.state.companyType}
                      name="companyType"
                      onChange={(event) => this.handleChange(event)}
                    >
                      <option value="">
                        {t("Who are you?", "Who are you?")}
                      </option>
                      <option value="b">{t("Retailer", "Retailer")}</option>
                      <option value="s">{t("Brand", "Brand")}</option>
                    </select>
                    <input
                      disabled={!this.state.companyType}
                      name="companyName"
                      value={this.state.companyName}
                      onChange={this.handleChange.bind(this)}
                      type="text"
                      placeholder={t("Company Name", "Company Name")}
                    />
                    <input
                      disabled={!this.state.companyType}
                      name="companyWebsite"
                      value={this.state.companyWebsite}
                      onChange={this.handleChange.bind(this)}
                      type="text"
                      placeholder={t("Company Website or Instagram", "Company Website or Instagram")}
                    />
                    <input
                      disabled={!this.state.companyType}
                      name="yearEstablished"
                      value={this.state.yearEstablished}
                      onChange={this.handleChange.bind(this)}
                      type="text"
                      placeholder={t("Year Established", "Year Established")}
                    />
                    {this.state.countries &&
                      this.state.countries.length > 0 &&
                      !this.state.loading && (
                        <Select
                          options={this.selectOptionsCountries(
                            this.state.countries
                          )}
                          isMulti
                          placeholder={t(
                            "Select an country",
                            "Select an country"
                          )}
                          styles={{
                            control: (control) => ({
                              ...control,
                              minHeight: "32px",
                              fontSize: "14px",
                              borderSize: "2px",
                              marginTop: "6px",
                            }),
                          }}
                          theme={(theme) => ({
                            ...theme,
                            borderRadius: 0,
                            colors: {
                              ...theme.colors,
                              primary25: "#dddddd",
                              primary: "#c0c0c0",
                            },
                          })}
                          classNamePrefix="react-select"
                          value={undefined}
                          isDisabled={false}
                          onChange={(value) =>
                            this.handleChangeSelectCountry(value)
                          }
                        />
                      )}
                    {this.state.locationFields.map((item, index) => {
                      return (
                        <div key={index} className="auto-complete-group">
                          <Autocomplete
                            key={index}
                            style={{ width: "100%" }}
                            onPlaceSelected={(place) => {
                              this.setCompanyLocation(place, index);
                            }}
                            types={["(regions)"]}
                            placeholder={
                              t(
                                "Location of Business Operations",
                                "Location of Business Operations"
                              )
                            }
                          />
                          {index !== 0 && (
                            <FontAwesomeIcon
                              onClick={() => this.removeLocation(index)}
                              icon="times-circle"
                            />
                          )}
                        </div>
                      );
                    })}
                    {this.state.companyType === "b" && (
                      <div
                        onClick={() => this.addLocationField()}
                        className="add-location"
                      >
                        <FontAwesomeIcon icon="plus-circle" />
                        <span>
                          {t("add more locations", "add more locations")}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="contact-info">
                    <span className="subtitle">
                      {t("CONTACT INFO", "CONTACT INFO")}
                    </span>
                    <input
                      disabled={!this.state.companyType}
                      name="firstName"
                      value={this.state.firstName}
                      onChange={this.handleChange.bind(this)}
                      type="text"
                      placeholder={t("First Name", "First Name")}
                    />
                    <input
                      disabled={!this.state.companyType}
                      name="lastName"
                      value={this.state.lastName}
                      onChange={this.handleChange.bind(this)}
                      type="text"
                      placeholder={t("Last Name", "Last Name")}
                    />
                    <input
                      disabled={!this.state.companyType}
                      name="phone"
                      value={this.state.phone}
                      onChange={this.handleChange.bind(this)}
                      type="text"
                      placeholder={t("Phone", "Phone")}
                    />
                    <input
                      disabled={!this.state.companyType}
                      name="email"
                      value={this.state.email}
                      onChange={this.handleChange.bind(this)}
                      type="email"
                      placeholder={t("Email", "Email")}
                    />
                    {this.state.eventSegments &&
                      this.state.eventSegments.length > 0 &&
                      !this.state.loading && (
                        <span className="subtitle">
                          {t("ATTENDING AN EVENT", "ATTENDING AN EVENT")}?
                        </span>
                      )}
                    {this.state.eventSegments &&
                      this.state.eventSegments.length > 0 &&
                      !this.state.loading && (
                        <Select
                          options={this.selectOptions(this.state.eventSegments)}
                          isMulti
                          placeholder={t("Select an Event", "Select an Event")}
                          styles={{
                            control: (control) => ({
                              ...control,
                              minHeight: "32px",
                              fontSize: "14px",
                              borderSize: "2px",
                            }),
                          }}
                          theme={(theme) => ({
                            ...theme,
                            borderRadius: 0,
                            colors: {
                              ...theme.colors,
                              primary25: "#dddddd",
                              primary: "#c0c0c0",
                            },
                          })}
                          classNamePrefix="react-select"
                          value={undefined}
                          isDisabled={false}
                          onChange={(value) =>
                            this.handleChangeSelectEvent(value)
                          }
                        />
                      )}
                  </div>
                  <div className="checkbox-group">
                    <label className="receive-news-checkbox">
                      {t(
                        "Receive news and updates from us",
                        "Receive news and updates from us"
                      )}
                      <input
                        type="checkbox"
                        name="addEmailToList"
                        onClick={() =>
                          this.setState({
                            available_for_mailing:
                              !this.state.available_for_mailing,
                          })
                        }
                      />
                      <span className="checkmark" />
                    </label>
                  </div>
                  <button
                    disabled={!this.state.companyType}
                    className="register-button"
                    type="submit"
                  >
                    {this.state.isLoading ? (
                      <SpinnerComponent />
                    ) : (
                      t("SEND", "SEND")
                    )}
                  </button>

                  <div id="error-box" className="email-box">
                    {this.state.emailAlreadyInPreOrder && (
                      <p className="fieldError">
                        {t("emailAlreadyInPreOrder", "emailAlreadyInPreOrder")}
                      </p>
                    )}

                    {this.state.emailAlreadyInUser && (
                      <p className="fieldError">
                        {t("emailAlreadyInUser", "emailAlreadyInUser")}
                      </p>
                    )}

                    {this.state.companyWebSiteUrl && (
                      <p className="fieldError">
                        {t(
                          "COMPANY WEBSITE INVALID",
                          "COMPANY WEBSITE INVALID"
                        )}
                      </p>
                    )}

                    {this.state.fieldError && (
                      <p className="fieldError">
                        Error: {this.state.fieldError}
                      </p>
                    )}
                  </div>
                </React.Fragment>
              )}
              {this.state.registerSuccess && (
                <div className="success-text">
                  <span>
                    {t(
                      "Complete the registration through the email we sent to the address provided.",
                      "Complete the registration through the email we sent to the address provided."
                    )}
                  </span>
                  <a
                    className="register-button text-large"
                    href="/brands"
                  >
                    {t("MEET OUR BRANDS", "MEET OUR BRANDS")}
                  </a>
                </div>
              )}
            </div>
          </form>
        </div>
      </LightboxHalfScreenComponent>
    );
  }
}

export default withTranslation()(withRouter(RegisterModalComponent));
